import React, { useState } from 'react';
import Contact from '../Contact/Contact';
import WelcomeMassage from './WelcomeMassage';
import GridMLR from './GridMLR/GridMLR';
import GridILR from './GridILR';
import { useNavigate } from 'react-router-dom';
import PieChart from './PieChart';
const MainDashBoard = () => {
  //  const [activeTab, setActiveTab] = useState('UPAS');
    const navigate = useNavigate();
    const handleNewLoanApplication = () => {
      navigate('/NewLoanApplication');
    };
  return (
    <div>
      <WelcomeMassage />
      {/* <StepOne/> */}

      {/* <div className="md:px-10 px-0 md:py-0 py-2 mt-10 flex items-center"></div> */}
      {/* pie charts */}
      <div className="w-full md:px-10 px-0 md:py-0 py-2 mt-4 ">
        {/* New UPAS/LC Application
        <div className="w-full md:w-1/4 mb-2 md:px-0 px-2">
          <button
            onClick={handleNewLoanApplication}
            className="bg-headerBtn md:text-xl text-[10px] text-white  md:px-6  md:py-4 py-2 px-1.5 rounded-md hover:bg-btnHover transition duration-200 w-full md:w-full"
          >
            New UPAS/LC Application
          </button>
        </div> */}
        <PieChart />
      </div>

      <div className="md:px-10 px-0 md:py-10 py-2">
        {/* New UPAS/LC Application */}
        <div className="w-full md:w-1/4 mb-2 md:px-0 px-2 md:-mt-20 2xl:-mt-20">
          <button
            onClick={handleNewLoanApplication}
            className="bg-headerBtn md:text-lg text-[10px] text-white  md:px-6  md:py-2 py-2 px-1.5 rounded-md hover:bg-btnHover transition duration-200 w-full md:w-full"
          >
            New UPAS/LC Application
          </button>
        </div>
        <GridMLR />
      </div>

      <div className="md:px-10 px-2 md:py-10 py-6">
        <GridILR />
      </div>

      <Contact />
      {/* <Footer /> */}
    </div>
  );
};

export default MainDashBoard;
